import { Checkbox } from '@repo/ui/components'
import type { AdvancedTradeBoxCheckboxProps } from './advanced-trade-box.types'

export const AdvancedTradeBoxCheckbox = ({
  checked,
  onChange,
  label,
}: AdvancedTradeBoxCheckboxProps) => {
  return (
    <div className='flex items-center gap-xs'>
      <Checkbox checked={checked} onCheckedChange={onChange} size='sm' />
      <span className='text-sm'>{label}</span>
    </div>
  )
}
